import React from 'react';
import { LucideIcon } from 'lucide-react';

interface NavigationButtonProps {
    icon: LucideIcon;
    label: string;
    isActive: boolean;
    onClick: () => void;
    isPrimary?: boolean;
    isSecondary?: boolean;
    hasAlert?: boolean;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({
    icon: Icon,
    label,
    isActive,
    onClick,
    isPrimary = false,
    isSecondary = false,
    hasAlert = false
}) => {
    const getButtonStyles = () => {
        if (isPrimary) {
            return isActive
                ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                : 'text-slate-800 hover:bg-gradient-to-r hover:from-blue-50 hover:to-purple-50 hover:text-blue-700';
        }

        if (isSecondary) {
            return isActive
                ? 'bg-slate-100 text-slate-800'
                : 'text-slate-600 hover:bg-slate-50 hover:text-slate-800';
        }

        return isActive
            ? 'bg-blue-50 text-blue-700 border border-blue-200'
            : 'text-slate-700 hover:bg-slate-50';
    };

    return (
        <button
            onClick={onClick}
            className={`relative w-full flex items-center px-4 py-3 rounded-xl text-left transition-all duration-200 ${getButtonStyles()}`}
        >
            <Icon className={`w-5 h-5 mr-3 ${isPrimary && isActive ? '' : ''}`} />
            <span className={`font-medium ${isPrimary ? 'font-semibold' : ''}`}>
                {label}
            </span>
            {hasAlert && (
                <div className="ml-auto">
                    <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                </div>
            )}
        </button>
    );
};

export default NavigationButton;
